import React from 'react';
import { motion } from 'framer-motion';
import { processSteps } from '../data/siteData';

function Approach() {
  return (
    <section className="section section--light approach" id="approach">
      <div className="section-heading">
        <div>
          <span className="section-label">How we work</span>
          <h2>Built fast.<br />Built right.</h2>
        </div>
        <p>
          No drawn-out transformation programs. We move from a clear
          opportunity to a working system through focused, transparent stages.
        </p>
      </div>

      <ol className="process-list">
        {processSteps.map((step, index) => (
          <motion.li
            className="process-item"
            key={step.title}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.06, duration: 0.45 }}
          >
            <span className="process-number">{step.number}</span>
            <h3>{step.title}</h3>
            <p>{step.text}</p>
          </motion.li>
        ))}
      </ol>
    </section>
  );
}

export default Approach;
